import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import { MINDALAY_ADMIN, PAYMENT_PACKAGE_KEY, PAYMENT_PACKAGES_KEY, PAYMENT_RECEIPT_KEY, PAYMENT_HISTORY_KEY } from "../../../../Constants/urlKeys";
import TranslationService from "../../../../Services/translationService";
import { showOrHideGeneralDashboardLeftMenu } from '../../../../Store/Actions/generalLeftMenu';

const PaymentPackageSubMneu = (props) => {
  const dispatch = useDispatch();
  const language = useSelector(state => state.language.language);
  const translations = useSelector(state => state.translation.translations);
  const [translationService, setTranslationService] = useState(null);

  useEffect(() => {
    setTranslationService(new TranslationService(translations));
  }, [translations]);

  const showOrHideLeftMenu = (bool) => {
    dispatch(showOrHideGeneralDashboardLeftMenu(bool));
  }

  return translationService ? <aside className="side-left-submenu">
    <div className="side-left-submenu-container">
      <ul className="side-left-submenu-list">
        <li className="side-left-submenu-item">
          <NavLink
            to={`/${language}/${MINDALAY_ADMIN}/${PAYMENT_PACKAGE_KEY}/${PAYMENT_RECEIPT_KEY}`}
            className={props.location.pathname.includes(`/${PAYMENT_RECEIPT_KEY}`) ? "active-text" : ""}
            onClick={() => showOrHideLeftMenu(false)}
          >
            {translationService.translate("TR_PAYMENT_RECEIPT")}
          </NavLink>
        </li>
        <li className="side-left-submenu-item">
          <NavLink
            to={`/${language}/${MINDALAY_ADMIN}/${PAYMENT_PACKAGE_KEY}/${PAYMENT_HISTORY_KEY}`}
            className={props.location.pathname.includes(`/${PAYMENT_HISTORY_KEY}`) ? "active-text" : ""}
            onClick={() => showOrHideLeftMenu(false)}
          >
            {translationService.translate("TR_PAYMENT_HISTORY")}
          </NavLink>
        </li>

      </ul>
    </div>
  </aside> : null;
}

export default withRouter(PaymentPackageSubMneu);